import api from './http-common';
import { format, parse } from 'date-fns';
import { SERVER } from '../common/const/networkUrls';
import { IsUnauthorized } from '../common/utility/utility';

export async function fetchOverviewApi() {
    const response = await api.get(`${SERVER.SERVICES.getOverview}`);
    const body = await response;
    return body.data;
}

export async function fetchOverviewDetailsApi(overviewDetailsRequest) {
    overviewDetailsRequest = {
        ...overviewDetailsRequest,
        FromDate: format(parse(overviewDetailsRequest.FromDate, "dd/MM/yyyy", new Date()), "MM/dd/yyyy"),
        ToDate: format(parse(overviewDetailsRequest.ToDate, "dd/MM/yyyy", new Date()), "MM/dd/yyyy")
    }
    const response = await api.post(`${SERVER.SERVICES.getOverviewDetails}`, overviewDetailsRequest);
    const body = await response;
    return body.data;
}

export async function updateOverviewRevenueDetailsApi(updateDetailRequestModel) {
    const response = await api.put(`${SERVER.SERVICES.updateOverviewDetails}`, updateDetailRequestModel);
    const body = await response;
    return body.data;
}

export async function uploadCashRegisterApi(requestFormData) {
    const response = await api.put(`${SERVER.SERVICES.uploadCashRegisterFile}`, requestFormData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

    const body = await response;
    return body.data;
}

export async function submitChangeRequestActionApi(changeId, remarks, actionId, modifiedBy) {
    const changeRequestActionRequest = {
        "ChangeRequestNumber": changeId,
        "ApproverRemarks": remarks,
        "Status": +actionId,
        "ModifiedBy": modifiedBy
    }

    const response = await api.put(`${SERVER.SERVICES.getChangeRequestOverviewDetails}`, changeRequestActionRequest);
    const body = await response;
    return body.data;
}

export async function fetchReportsDataApi() {
    const response = await api.get(`${SERVER.SERVICES.getReportDetails}`);
    const body = await response;
    return body.data;
}

export async function pendingCrStatusApi() {
    try {
        const response = await api.get(`${SERVER.SERVICES.getPendingCrStatus}`);
        const body = await response;
        return body.data;
    } catch (error) {
        IsUnauthorized(error);
        return error;
    }
}